export const compareSortKey = (a: number, b: number) => (a === b ? 0 : a < b ? -1 : +1);
